import Dialog from "@mui/material/Dialog";
import { ComponentProps } from "../types";
import { Box, DialogActions, DialogContent, DialogTitle, Divider, LinearProgress, PaperProps } from "@mui/material";
import DashboardEnvContext from "../DashboardEnvContext";
import { CSSProperties, useContext, useEffect, useMemo, useState } from "react";
import DashboardPageContext from "../DashboardPageContext";
import DashboardComponent from "./DashboardComponent";
import ExecutionTypeContext, { Mode } from "../ExecutionTypeContext";
import PagetActionsContext from "../PagetActionsContext";

function Component({ component, evaluteScript, evalJsText }: ComponentProps) {
	// eslint-disable-next-line @typescript-eslint/no-unused-vars
	const dashboard = useContext(DashboardEnvContext);
	// eslint-disable-next-line @typescript-eslint/no-unused-vars
	const pageContext = useContext(DashboardPageContext);
	const exeMode = useContext(ExecutionTypeContext);
	const [isLoading, setIsLoading] = useState<boolean>(false);
	const pageActions = useContext(PagetActionsContext);

	const args = useMemo(() => {
		const args = {} as { [key: string]: unknown };
		args["onClose"] = () => {
			let actionPayload = undefined as unknown;
			if (component.properties["closeHandler_Payload"]) {
				actionPayload = evaluteScript("const payload = " + component.properties["closeHandler_Payload"] + "; payload");
			}
			if (dashboard && component.properties["closeHandler"]) {
				pageActions.executePageAction(component.properties["closeHandler"], {
					row: undefined,
					actionPayload: undefined,
				});
			}
		};
		if (component.properties["openCondition"]) args["open"] = evaluteScript(component.properties["openCondition"]);
		if (!args["open"]) args["open"] = false;
		if (component.properties["maxWidth"]) args["maxWidth"] = component.properties["maxWidth"] === "False" ? false : component.properties["maxWidth"];
		if (component.properties["fullWidth"]) args["fullWidth"] = component.properties["fullWidth"] === "True" ? true : false;

		const style = {} as CSSProperties;
		if (component.properties["width"]) {
			style.width = "100%";
			style.maxWidth = component.properties["width"] + " !important";
		}
		if (component.properties["height"]) style.height = component.properties["height"];

		const paperProps = {
			sx: style,
		} as PaperProps;
		args["PaperProps"] = paperProps;

		return args;
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [component, pageContext.context]);

	const dialogActions = useMemo(() => {
		return component.childern.filter((c) => c.type === "DialogActions")[0];
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [component, pageContext.context]);

	useEffect(() => {
		if (component.properties["loadingIndicator"]) {
			setIsLoading(evaluteScript(component.properties["loadingIndicator"]) as boolean);
		}
	}, [pageContext.context]);

	return (
		<Dialog open={component.properties["closeHandler"] ? (args["open"] as boolean | false) : false} {...args} scroll="paper">
			<DialogTitle>{evalJsText(component.properties["title"])}</DialogTitle>
			{isLoading === true ? <LinearProgress color="secondary" sx={{ height: 3 }} /> : <Box sx={{ height: 3 }} />}
			<Divider />
			<DialogContent>{component.childern && component.childern.filter((c) => c.type !== "DialogActions").map((c, i) => <DashboardComponent key={i} component={c} />)}</DialogContent>
			{dialogActions && (
				<>
					<Divider />
					<DialogActions>
						<DashboardComponent component={dialogActions} />
					</DialogActions>
				</>
			)}
		</Dialog>
	);
}

export default Component;
